export const blenderParameterComponents = [
    "black_level",
    "blend_color",
    "blend_factor",
    "blend_type",
    "clip_min_x",
    "clip_min_y",
    "clip_max_x",
    "clip_max_y",
    "color_mapping",
    "color_mode",
    "direction_type",
    "use_color_ramp",
    "color_ramp",
    "colorspace_settings",
    "cycles_mapping_table",
    "cycles_ramp_alpha_table",
    "cycles_ramp_color_table",
    "from_instancer",
    "handle_type",
    "hue_interpolation",
    "is_active_output",
    "is_active",
    "mapping_x",
    "mapping_y",
    "mapping_z",
    "projection_blend",
    "subsurface_method",
    "texture_mapping",
    "use_alpha",
    "use_clamp",
    "use_clip",
    "use_max",
    "use_min",
    "uv_map_index",
    "uv_map",
    "vector_type",
    "white_level",
    "noise_dimensions",
    "noise_type",
    "clamp_factor",
    "clamp_result",
    "only_local",
    "data_type",
    "interpolation_type",
    "factor_mode",
    "offset_frequency",
    "squash_frequency",
    "gradient_type",
    "musgrave_dimensions",
    "musgrave_type",
    "voronoi_dimensions",
]
